import State from 'store/State';
import { selectComponentKeysByType } from 'layout/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { selectWidgetInstancesState } from 'widgets/store/selectors';

export const selectLiquiditySummaryWidgetKeys: (state: State) => string[] = (
    state
) => selectComponentKeysByType(state, WidgetType.LIQUIDITY_SUMMARY);

export const selectLiquiditySummarysWidgetsState = (state: State) =>
    selectWidgetInstancesState(state).liquiditySummary;

export const selectLiquiditySummaryState = (state: State, widgetKey: string) =>
    selectLiquiditySummarysWidgetsState(state)[widgetKey];
